<template>
    <nav :class="[bemRoot, bemFacets]">
        <ul class="language-menu--collection u-reset" v-if="itemsPaths.length">
            <li class="language-menu--item" v-for="(item, index) in items" :key="index">
                <a class="language-menu--link u-reset" :href="itemsPaths[index]" :class="getLinkClasses(item)">
                    {{ item.abbr }}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
    import { mapState } from 'vuex';

    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [bemMixin('language-menu')],
        props: {
            children: {
                type: Array,
                required: true,
            },
        },
        computed: {
            ...mapState('page', ['languageSiblings']),
            /** @type {ILink[]} */
            items: {
                get() {
                    return this.children.map(item => item.content);
                },
            },
            itemsPaths() {
                return Object.values(this.languageSiblings);
            },
        },
        methods: {
            /**
             * Get the classes to append to the link DOM node
             * @param {ILink} item - link item object
             * @return {Object|null} link classes
             */
            getLinkClasses(item) {
                return this.bemAdd(item.active ? 'active' : '', 'link');
            },
        },
    };
</script>
